<template>
	<div class="flex flex-col min-h-screen relative">
		<div class="relative top-0 z-20 transition-transform duration-200">
			<OrganismHeaderBar
				is-sales-header
				:phone-number="phoneNumber"
				:phone-link="phoneLink"
				:home-link="homeLink"
			/>
		</div>

		<div
			v-if="backgroundImage"
			class="absolute top-0 right-0 left-0 h-full"
		>
			<LazyAtomImage
				img-class="w-full h-full left-0 top-0 object-cover"
				:src="backgroundImage.src"
				:alt="backgroundImage.alt"
				:quality="80"
				loading="eager"
			/>
		</div>

		<div
			v-if="breadcrumbs"
			class="container relative mt-8"
		>
			<LazyAtomBreadcrumbs
				class="text-functional-size-sm"
				:breadcrumbs="breadcrumbs"
			/>
		</div>

		<main :class="['relative grow', classNames]">
			<slot />
		</main>

		<footer
			class="relative pt-6 pb-10 text-paragraph-size-md flex flex-col items-center gap-24 justify-center bg-gray-200"
		>
			<p class="text-gray-400 text-paragraph-size-sm text-center">
				© 2023 - {{ legalName }}
			</p>
		</footer>
	</div>
	<OrganismNotifications />
</template>

<script lang="ts" setup>
import { homeLink, phoneLink } from '#fysio/core/consts/links';
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import type { ImageType } from '#base/core/types/ImageType';
import { legalName, phoneNumber } from '#base/core/consts/companyData';

const {
	backgroundImage,
	breadcrumbs,
	class: classNames,
} = defineProps<{
	backgroundImage?: ImageType;
	breadcrumbs?: BreadcrumbsType;
	class?: string | object | string[];
}>();

useExternalScripts();
</script>
